export default __webpack_public_path__ + "static/insta-hotels-1-c0ef69f8f637671f548b3529da806908.jpg";